import Row from './Row.js'
import Wall from './Wall.js'
import Fragment from './Fragment.js'
import Form from './Form.js'
import RowHeading from './RowHeading.js'
import './styles.scss'

export default {
    row: Row,
    fragment: Fragment,
    wall: Wall,
    form: Form,
    rowHeading: RowHeading,
}
